import { Alert } from '@efast_public/fjd-component-library';
import { ConfirmAction } from '../../api/models/UploadFiles/ConfirmAction';

interface UploadFilesConfirmationAlertProps {
  readonly confirmAction: ConfirmAction;
}

export default function UploadFilesConfirmationAlert({
  confirmAction
}: UploadFilesConfirmationAlertProps) {
  return (
    <Alert
      data-testid="confirmationAlert"
      variant="warning"
      message={confirmAction.message}
    />
  );
}
